var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.727 4h10.92c9.607 0 11.3 5.235 9.943 12.598-.918 4.943-3.202 8.73-7.041 10.512-1.737.794-3.367 1.244-7.212 1.244H5.441l.904-5.066 9.582.006c5.762.006 7.298-2.49 8.046-4.68.28-.824.93-3.36.953-4.856.04-2.922-1.39-4.686-6.247-4.686L8.821 9.06 9.728 4zM1.483 16.586c.27-1.132.702-2.951 3.531-2.951h11.184s-.117.601-.473 2.074l-.01.04c-.27 1.13-.702 2.95-3.531 2.95H1s.117-.601.473-2.074l.01-.04z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/DASH.f177d4e5ede4c15bc8ae8c4090d20472.svg";
export { ForwardRef as ReactComponent };